import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=2449916d&scoped=true&"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordForm.vue?vue&type=style&index=0&id=2449916d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2449916d",
  null
  
)

export default component.exports